import axiosInstance from "../../../services/axiosInstance";
import { STATUSES } from "./apiStatus";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const postpaidBillPayment = createAsyncThunk(
  "postpaidBillPayment/fetch",
  async (apiData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(`/EsignServices/payPostpaidPerID/${apiData.id}` , {username:apiData.userName});
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const postpaidBillPaymentSlice = createSlice({
  name: "postpaidBillPayment",
  initialState: {
    postpaidData: {},
    status: STATUSES.IDLE,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postpaidBillPayment.pending, (state, action) => {
        state.status = STATUSES.LOADING;
      })
      .addCase(postpaidBillPayment.fulfilled, (state, action) => {
        state.postpaidData = action.payload;
        state.status = STATUSES.IDLE;
      })
      .addCase(postpaidBillPayment.rejected, (state, action) => {
        state.status = STATUSES.ERROR;
        state.error = action.payload;
      });
  },
});

export default postpaidBillPaymentSlice.reducer;

